<template>
  <div :class="state">
    <div class="container">
      <div class="wrapper">
        <a href="" >
          <div class="icon-div" style="float: left">
            <div class="main-icon">
              <img style="width: .7rem" src="../assets/logo.png" alt=""/>
            </div>
            <div class="h0"> 上海力普科技服务公司</div>
          </div>
        </a>
        <div v-if="state==='pc'" style="float: right;">
          <el-menu :default-active="activeIndex" mode="horizontal" text-color="#464646" active-text-color="#898989" router>
            <el-menu-item index="home">首页</el-menu-item>
            <el-menu-item index="about">企业介绍</el-menu-item>
            <el-menu-item index="product">产品中心</el-menu-item>
            <el-menu-item index="news">新闻中心</el-menu-item>
            <el-menu-item index="contact">联系我们</el-menu-item>
          </el-menu>
        </div>
        <el-menu v-else-if="state==='mobile'"
            style="float: right;"
            :default-active="activeIndex"
            mode="horizontal"
            text-color="#254b7c"
            active-text-color="#254b7c"
            router
            :ellipsis="false">
          <el-sub-menu>
            <template #title>...</template>
            <el-menu-item index="home">首页</el-menu-item>
            <el-menu-item index="about">企业介绍</el-menu-item>
            <el-menu-item index="product">产品中心</el-menu-item>
            <el-menu-item index="news">新闻中心</el-menu-item>
            <el-menu-item index="contact">联系我们</el-menu-item>
          </el-sub-menu>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, ref, watch } from "vue";
import { useRoute } from 'vue-router'

export default {
  setup() {
    const state = computed(() => useStore().state.client);
    const activeIndex = ref('home')
    const route = useRoute()
    watch(() => route.path, () => {
      activeIndex.value !== route.path.substring(1) ? activeIndex.value = route.path.substring(1) : null
    })
    return {
      state,
      activeIndex
    };
  },
};
</script>

<style lang="scss">
.pc {
  --el-menu-bg-color: transparent;
  --el-menu-hover-bg-color: transparent;
  --el-menu-text-color: #fff !important;
  --el-menu-hover-text-color: white;
  --el-menu-active-color:white;
  --el-menu-hover-text-color: white;

  .container {

    .h0 {
      float: left;
      padding-top: .09rem;
      margin-left: .2rem;
      font-size: .4rem;
      color:white;
      font-weight: 600;
    }

    .main-icon{
      padding: .08rem;
      background: white;
      width: .7rem;
      border-radius: 12px;
      float: left;
    }

    width: 100%;
    height: .9rem;
    margin: .1rem auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    position: absolute;
    z-index: 999;

    a {
      font-size: 0;
    }

    .el-menu {
      border: none;
      width: 5.6rem;
      .el-menu-item {
        font-size: .16rem;
        color: white !important;
      }

      .is-active {
        color: white !important;
      }

      .is-active {
        border-bottom-color: #254b7c !important;
        color: white !important;
      }
    }
  }
}

.mobile {
  --el-menu-bg-color: transparent;
  --el-menu-hover-bg-color: transparent;
  --el-menu-text-color: #fff !important;
  --el-menu-hover-text-color: white;
  --el-menu-active-color:white;
  --el-menu-hover-text-color: white;

  .icon-div{
    margin: .3rem .0rem .0rem .0rem;
  }

  .container {

    width: 100%;
    height: .9rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    position: absolute;
    z-index: 999;

    .main-icon{
      padding: .08rem;
      background: white;
      width: .7rem;
      border-radius: 12px;
      float: left;
    }

    .h0{
      float: left;
      padding-top: .09rem;
      margin-left: .2rem;
      font-size: .4rem;
      color:white;
      font-weight: 600;
    }


    a {
      font-size: 0;
    }


    .el-menu {
      border: none;
      width: 1rem;
      .el-menu-item {
        font-size: .16rem;
        color: white !important;
      }

      .is-active {
        color: white !important;
      }

      .is-active {
        border-bottom-color: #254b7c !important;
        color: white !important;
      }

      .el-sub-menu__title{
        border-bottom-color: transparent !important;
      }
    }
  }
}
</style>
